<template>
  <div class="schedule-ps--container">
    <div v-for="(item, idx) in list" :key="item.id" class="shadow-card mrg-t-10">
      <div><b>Правило #{{ idx+1 }}</b></div>
      <div>
        <span v-if="item.start_logic.type == 'by_weekday'">
          Запускается 
          <span 
            v-if="
              item.start_logic.value == 1 || 
              item.start_logic.value == 2 ||  
              item.start_logic.value == 4 
            "
          >
            <b>каждый</b>
          </span>
          <span
            v-if="
              item.start_logic.value == 5 || 
              item.start_logic.value == 6 || 
              item.start_logic.value == 3
            "
          >
            <b>каждую</b>
          </span>
          <span v-if="item.start_logic.value == 0">
            <b>каждое</b>
          </span>
          <span v-if="item.start_logic.value == 1"><b> понедельник</b></span>
          <span v-if="item.start_logic.value == 2"><b> вторник</b></span>
          <span v-if="item.start_logic.value == 3"><b> среду</b></span>
          <span v-if="item.start_logic.value == 4"><b> четверг</b></span>
          <span v-if="item.start_logic.value == 5"><b> пятницу</b></span>
          <span v-if="item.start_logic.value == 6"><b> субботу</b></span>
          <span v-if="item.start_logic.value == 0"><b> воскресенье</b></span>
        </span>
        <span v-if="item.start_logic.type == 'before_end_month'">
          Запускается <b>за {{ item.start_logic.value }} дней до конца месяца</b>
        </span>
      </div>
      <div>
        Устанавливает <b>график с {{ minuteToTime(item.what_set.schedule.time_from) }} до 
        {{ minuteToTime(item.what_set.schedule.time_to) }}</b>
      </div>
      <div v-if="item.what_set.breaks && item.what_set.breaks.length > 0">
        <b>С перерывом (-ами):</b>
        <span v-for="(brk, idx) in item.what_set.breaks" :key="idx">
          c {{ minuteToTime(brk.break_from) }} до {{ minuteToTime(brk.break_to) }}; 
        </span>
      </div>
      <div>
        Для сотрудников: 
        <span v-for="(staffId, idx) in item.what_set.staff_ids" :key="idx">
          <b>{{ getStaffName(staffId) }}</b>; 
        </span>
      </div>
      <div class="mrg-t-5">
        <div>Дни недели в которые будет установлено расписание:</div>
        <div
          v-for="(week, idx) in item.what_set.where_to_set.data" :key="idx"
        >
          {{ idx + 1 }}-я неделя: 
          <span v-for="(day, idx) in week" :key="idx">
            <b>
            <span v-if="day == 1"> Пн</span>
            <span v-if="day == 2"> Вт</span>
            <span v-if="day == 3"> Ср</span>
            <span v-if="day == 4"> Чт</span>
            <span v-if="day == 5"> Пт</span>
            <span v-if="day == 6"> Сб</span>
            <span v-if="day == 0"> Вс</span>
            </b>
          </span>
        </div>
      </div>
      <div class="mrg-t-5 text-right">
        <div @click="deletePlanner(item.id)" class="btn-badge btn-danger">Удалить правило</div>
      </div>
    </div>

    <div v-if="showCreateButton" class="mrg-t-15 text-center">
      <div @click="createRule" class="btn btn-sm btn-info">
        <f-awesome icon="plus"></f-awesome>
        Создать новое правило
      </div>
    </div>
    <div class="shadow-card mrg-t-10" v-show="!showCreateButton">
      <div class="text-center text-bold mrg-b-10">Параметры нового правила</div>
      <div class="input-block">
        <label for="newPlanner_start_logic_type">Режим, когда будет применяться правило</label>
        <select
            id="newPlanner_start_logic_type"
            v-model="newPlanner.start_logic.type"
        >
          <option value="by_weekday">В определенный день недели</option>
          <option value="before_end_month">За выбранное кол-во дней до конца месяца</option>
        </select>
      </div>

      <div v-if="newPlanner.start_logic.type == 'by_weekday'" class="input-block">
        <label for="newPlanner_start_logic_value">
          Выберите день недели, когда будет применяться правило
        </label>
        <select
            v-model="newPlanner.start_logic.value"
        >
          <option value="1">Понедельник</option>
          <option value="2">Вторник</option>
          <option value="3">Среда</option>
          <option value="4">Четверг</option>
          <option value="5">Пятница</option>
          <option value="6">Суббота</option>
          <option value="0">Воскресенье</option>
        </select>
      </div>

      <div v-if="newPlanner.start_logic.type == 'before_end_month'" class="input-block">
        <label for="newPlanner_start_logic_value">
          Выберите за сколько дней до конца месяца применять правило
        </label>
        <select
            v-model="newPlanner.start_logic.value"
        >
          <option value="5">За 5 дней</option>
          <option value="10">За 10 дней</option>
          <option value="15">За 15 дней</option>
        </select>
      </div>

      <div 
        v-if="newPlanner.start_logic.type !== '' && newPlanner.start_logic.value !== ''" 
        class="mrg-t-15"
      >
        <div>Выберите задаваемый график работы</div>
        <div class="schedule-st--time-flex mrg-t-5">
          <div class="input-block">
            <label>Часы</label>
            <select v-model="newPlanner.what_set.schedule.from_hour">
              <option
                v-for="item in hourOptions"
                :key="item.value"
                v-bind:value="item.value"
                >{{ item.time }}</option>
            </select>
          </div>
          <div>
            <span>:</span>
          </div>
          <div class="input-block">
            <label>Минуты</label>
            <select v-model="newPlanner.what_set.schedule.from_minute">
              <option
                v-for="item in minuteOptions"
                :key="item.value"
                v-bind:value="item.value"
              >{{ item.time }}</option>
            </select>
          </div>
          <div>-</div>
          <div class="input-block">
            <label>Часы</label>
            <select v-model="newPlanner.what_set.schedule.to_hour">
              <option
                v-for="item in hourOptions"
                :key="item.value"
                v-bind:value="item.value"
                >{{ item.time }}</option
              >
            </select>
          </div>
          <div>
            <span>:</span>
          </div>
          <div class="input-block">
            <label>Минуты</label>
            <select v-model="newPlanner.what_set.schedule.to_minute">
              <option
                v-for="item in minuteOptions"
                :key="item.value"
                v-bind:value="item.value"
              >{{ item.time }}</option>
            </select>
          </div>
        </div>
      </div>

      <div v-if="newPlanner.start_logic.type !== '' && newPlanner.start_logic.value !== ''">
        <div class="input-block">
          <label>
            <input type="checkbox" v-model="showBreak" />
            С перерывом
          </label>
        </div>
      </div>

      <div 
        v-if="newPlanner.start_logic.type !== '' && newPlanner.start_logic.value !== ''" 
        v-show="showBreak" 
        class="schedule-st--break-container mrg-t-10"
      >
        <div v-for="(item) in newPlanner.what_set.breaks" :key="item.id">
          <div class="schedule-st--time-flex">
            <div class="input-block">
              <label>Часы</label>
              <select v-model="item.break_from_hour">
                <option
                    v-for="item in hourOptions"
                    :key="item.value"
                    v-bind:value="item.value"
                >{{ item.time }}</option>
              </select>
            </div>
            <div>
              <span>:</span>
            </div>
            <div class="input-block">
              <label>Минуты</label>
              <select v-model="item.break_from_minute">
                <option
                    v-for="item in minuteOptions"
                    :key="item.value"
                    v-bind:value="item.value"
                >{{ item.time }}</option>
              </select>
            </div>
            <div>-</div>
            <div class="input-block">
              <label>Часы</label>
              <select v-model="item.break_to_hour">
                <option
                    v-for="item in hourOptions"
                    :key="item.value"
                    v-bind:value="item.value"
                >{{ item.time }}</option
                >
              </select>
            </div>
            <div>
              <span>:</span>
            </div>
            <div class="input-block">
              <label>Минуты</label>
              <select v-model="item.break_to_minute">
                <option
                    v-for="item in minuteOptions"
                    :key="item.value"
                    v-bind:value="item.value"
                >{{ item.time }}</option>
              </select>
            </div>
          </div>

        </div>

        <div @click="addBreak" class="btn-badge btn-info mrg-t-10">
          <f-awesome icon="plus"></f-awesome>
          Еще один перерыв
        </div>
        <div @click="removeBreak" class="btn-badge btn-danger mrg-t-10">
          <f-awesome icon="times"></f-awesome>
          Убрать последний
        </div>
      </div>

      <div 
        v-show="
          newPlanner.what_set.schedule.from_hour !== '' && 
          newPlanner.what_set.schedule.to_minute !== ''
        " 
        class="mrg-t-15">
        <label>Выберите сотрудников, для которых применять правило</label>
        <simple-select-checkbox
          :dataComponent="staffList"
          :reset="resetCounter"
          :hideActions="true"
          @changeValue="changeStaffIds"
          class="mrg-t-5"
        ></simple-select-checkbox>
      </div>

      <div v-if="newPlanner.what_set.staff_ids.length > 0" class="mrg-t-15">
        <div class="mrg-b-10">
          Дни недели и на сколько недель вперед будет проставлено указанное расписание,
          где "1-я неделя" - это неделя применения правила
        </div>
        <div v-for="(item, idx) in newPlanner.what_set.where_to_set.data" :key="idx">
          <div class="mrg-t-10">{{ idx +1 }} - я неделя</div>
          <weekday-checker
            @emitComponent="setWeekdayChecker(idx, $event)"
            class="mrg-t-5"
          ></weekday-checker>
        </div>
        <div class="mrg-t-10">
          <div @click="addWeek" class="btn-badge btn-info mrg-t-5">
            <f-awesome icon="plus"></f-awesome>
            Добавить неделю
          </div>
          <div @click="deleteLastWeek" class="btn-badge btn-danger mrg-t-5">
            <f-awesome icon="times"></f-awesome>
            Убрать последнюю
          </div>
        </div>
      </div>

      <div class="mrg-t-20 text-center">
        <div 
          @click="createPlanner"
          v-if="newPlanner.what_set.where_to_set.data[0].length > 0" 
          class="btn btn-sm btn-success mrg-t-5"
        >
          Сохранить правило
        </div>
        <div @click="cancelCreateRule" class="btn btn-sm btn-danger mrg-t-5">Отменить создание</div>
      </div>

    </div>


    <popup
      :closeButton="deletePlannerPopup.closeButton"
      :actionButton="deletePlannerPopup.actionButton"
      :actionClass="deletePlannerPopup.actionClass"
      :show="deletePlannerPopup.show"
      @closePopup="closeDeletePlannerPopup"
      @actionPopup="deletePlannerSubmit"
    >
      <div slot="header">Подтвердить удаление?</div>
      <div slot="body">
        Правило будет удалено без возможности восстановления
      </div>
    </popup>


  </div>
</template>

<script>
import SimpleSelectCheckbox from '../../SimpleSelectCheckbox.vue';
import Popup from "@/components/Popup";
import WeekdayChecker from '../../WeekdayChecker.vue';
import Formatter from "../../libraries/Formatter";
import scheduleRepository from "../../../repositories/schedule";

const formatter = new Formatter();

export default {
  name: "SchedulePlannerSchedule",
  components: {SimpleSelectCheckbox, WeekdayChecker, Popup  },
  data() {
    return {
      list: [],
      resetCounter: 0,
      showCreateButton: true,
      newPlanner: {
        start_logic: {
          type: '',
          value: ''
        },
        what_set: {
          schedule: {
            from_hour: '',
            from_minute: '',
            to_hour: '',
            to_minute: ''
          },
          breaks: [],
          staff_ids: [],
          where_to_set: {
            type: 'by_week',
            data: [
              []
            ]
          }
        }
      },

      deletePlannerPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedPlannerId: 0,
      showBreak: false,
    };
  },
  props: {
    show: Boolean,
    staffList: Array
  },
  watch: {
    newPlanner: {
      handler: function(val) {
        if(val.start_logic.type === 'by_weekday'){
          if(
            val.start_logic.value == 10 ||
            val.start_logic.value == 15
          ){
            this.newPlanner.start_logic.value = '';
          }
        }else if(val.start_logic.type === 'before_end_month'){
          if(
            val.start_logic.value == 0 ||
            val.start_logic.value == 1 ||
            val.start_logic.value == 2 ||
            val.start_logic.value == 3 ||
            val.start_logic.value == 4 ||
            val.start_logic.value == 6
          ){
            this.newPlanner.start_logic.value = '';
          }
        }
        if(
          val.what_set.staff_ids.length === 0 && 
          this.newPlanner.what_set.where_to_set.data[0].length > 0
        ){
          this.newPlanner.what_set.where_to_set.data = [ [] ];
        }
      },
      deep: true
    },
    showBreak: function(val){
      if(!val){
        this.newPlanner.what_set.breaks = [];
        //this.addBreak();
      }else{
        this.addBreak();
      }
    },
    show: function(){
      this.resetCounter++;
    }
  },
  computed: {
    hourOptions(){
      let result = [];
      for (let i = 0; i <= 23; i++) {
        let obj = {};
        obj.value = i;
        obj.time = i;
        result.push(obj);
      }
      return result;
    },
    minuteOptions(){
      let result = [];
      for (let i = 0; i <= 55; i = i + 5) {
        let obj = {};
        obj.value = i;
        obj.time = i;
        result.push(obj);
      }
      return result;
    }
  },
  methods: {
    deletePlannerSubmit(){
      scheduleRepository.deletePlanner({ id: this.deletedPlannerId }).then(() => {
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
        this.closeDeletePlannerPopup();
        this.getList();
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeDeletePlannerPopup(){
      this.deletePlannerPopup.show = false;
    },
    deletePlanner(plannerId){
      this.deletedPlannerId = plannerId;
      this.deletePlannerPopup.show = true;
    },
    getStaffName(id){
      for(let key in this.staffList){
        if(+this.staffList[key].id === +id){
          return this.staffList[key].name;
        }
      }
    },
    minuteToTime(minutes){
      return formatter.minuteToTime(minutes);
    },
    getList(){
      scheduleRepository.getPlanner({ place: 'schedule' }).then(resp => {
        this.list = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    createPlanner(){
      let data = {
        place: 'schedule',
        start_logic: {
          type: this.newPlanner.start_logic.type,
          value: this.newPlanner.start_logic.value
        },
        what_set: {
          schedule: {
            time_from: formatter.hourMinuteToMinute(
                this.newPlanner.what_set.schedule.from_hour,
                this.newPlanner.what_set.schedule.from_minute
            ),
            time_to: formatter.hourMinuteToMinute(
                this.newPlanner.what_set.schedule.to_hour,
                this.newPlanner.what_set.schedule.to_minute
            )
          },
          breaks: [],
          staff_ids: [],
          where_to_set: {
            type: this.newPlanner.what_set.where_to_set.type,
            data: []
          }
        }
      };
      if(this.newPlanner.what_set.breaks.length > 0){
        for(let key in this.newPlanner.what_set.breaks){
          data.what_set.breaks[key] = {
            break_from: formatter.hourMinuteToMinute(
                this.newPlanner.what_set.breaks[key].break_from_hour,
                this.newPlanner.what_set.breaks[key].break_from_minute
            ),
            break_to: formatter.hourMinuteToMinute(
                this.newPlanner.what_set.breaks[key].break_to_hour,
                this.newPlanner.what_set.breaks[key].break_to_minute
            )
          };
        }
      }
      for(let key in this.newPlanner.what_set.staff_ids){
        data.what_set.staff_ids[data.what_set.staff_ids.length] = this.newPlanner.what_set.staff_ids[key];
      }

      let whereToSetData = [];
      for(let key in this.newPlanner.what_set.where_to_set.data){
        if (this.newPlanner.what_set.where_to_set.data[key].length) {
          whereToSetData[key] = [];
        }
        for(let keyWeek in this.newPlanner.what_set.where_to_set.data[key]){
          whereToSetData[key][whereToSetData[key].length] = this.newPlanner.what_set.where_to_set.data[key][keyWeek];
        }
      }
      data.what_set.where_to_set.data = whereToSetData;

      scheduleRepository.setPlanner(data).then(resp => {
        if(resp.data.result === 'ok'){
          this.cancelCreateRule();
          this.getList();
        }
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    resetPlanner(){
      this.newPlanner = {
        start_logic: {
          type: '',
          value: ''
        },
        what_set: {
          schedule: {
            from_hour: '',
            from_minute: '',
            to_hour: '',
            to_minute: ''
          },
          breaks: [],
          staff_ids: [],
          where_to_set: {
            type: 'by_week',
            data: [
              []
            ]
          }
        }
      };
    },
    cancelCreateRule(){
      this.showCreateButton = true;
      this.resetPlanner();
    },
    createRule(){
      this.showCreateButton = false;
    },
    addWeek(){
      if(this.newPlanner.what_set.where_to_set.data.length >= 10){
        this.$store.dispatch("addNotification", {
          text: 'Максимальное кол-во недель - 10',
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.newPlanner.what_set.where_to_set.data.push([]);
    },
    deleteLastWeek(){
      if(this.newPlanner.what_set.where_to_set.data.length <= 1){
        this.$store.dispatch("addNotification", {
          text: 'Нельзя убрать все недели',
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.newPlanner.what_set.where_to_set.data.splice(
        this.newPlanner.what_set.where_to_set.data.length - 1,
        1
      );
    },
    setWeekdayChecker(idx, val){
      for(let key in this.newPlanner.what_set.where_to_set.data){
        if(+key === +idx){
          //this.newPlanner.what_set.where_to_set[key]
          this.$set(this.newPlanner.what_set.where_to_set.data, key, val);
        }
      }
    },
    changeStaffIds(val){
      this.newPlanner.what_set.staff_ids = val;
    },
    addBreak(){
      let breakCount = this.newPlanner.what_set.breaks.length;
      if(breakCount >= 10){
        this.$store.dispatch("addNotification", {
          text: 'Нельзя добавить более 10 перерывов',
          time: 3,
          color: "danger"
        });
        return false;
      }
      let breakFields = {
        id: breakCount,
        break_from_hour: 0,
        break_from_minute: 0,
        break_to_hour: 0,
        break_to_minute: 0
      };
      this.newPlanner.what_set.breaks.push(breakFields);
    },
    removeBreak(){
      let breakCount = this.newPlanner.what_set.breaks.length;
      if(breakCount <= 1){
        this.$store.dispatch("addNotification", {
          text: 'Невозможно удалить. Если необходимо полностью убрать перерыв, то снимите галочку на пункте "С перерывом"',
          time: 5,
          color: "danger"
        });
        return false;
      }
      this.newPlanner.what_set.breaks.pop();
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    
  }
};
</script>

<style scoped lang="less">
.schedule-st--time-flex {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  & > div:nth-of-type(1) {
    width: 22%;
  }
  & > div:nth-of-type(2) {
    text-align: center;
    line-height: 60px;
    width: 2%;
  }
  & > div:nth-of-type(3) {
    width: 22%;
  }
  & > div:nth-of-type(4) {
    width: 5%;
    text-align: center;
    line-height: 60px;
  }
  & > div:nth-of-type(5) {
    width: 22%;
  }
  & > div:nth-of-type(6) {
    width: 2%;
    text-align: center;
    line-height: 60px;
  }
  & > div:nth-of-type(7) {
    width: 22%;
  }
}
</style>
